export const AI_CONFIGURATION_QUERY_KEY = ["genAIConfiguration"];
